import { Link, useLocation } from "react-router-dom";

/**
 * A link to one of the landing's sections, from anywhere in the marketing site.
 *
 * On the landing the target is on this page, so this renders the same native
 * anchor it always has — the browser does the jump, honouring the `scroll-mt-24`
 * the sections carry (#644), and no React state is involved. Anywhere else the
 * section lives on "/", so we route there with the hash and let the mount effect
 * below land it; without this, `#pricing` from /features resolved to
 * /features#pricing and did nothing.
 */
export default function SectionLink({
  hash,
  className,
  onNavigate,
  children,
}: {
  hash: string;
  className?: string;
  /** Called after the link is followed — used to close the mobile drawer. */
  onNavigate?: () => void;
  children: React.ReactNode;
}) {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return (
      <a href={hash} className={className} onClick={onNavigate}>
        {children}
      </a>
    );
  }
  return (
    <Link to={`/${hash}`} className={className} onClick={onNavigate}>
      {children}
    </Link>
  );
}
